import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { ConnectedButtonGroup } from "../ConnectedButtonGroup";
import { FilterChipGroup } from "../FilterChipGroup";
import type {
	LeaderboardFilterValue,
	LeaderboardScope,
	LeaderboardTimePeriod,
} from "./types";

type Props = {
	timePeriod: LeaderboardTimePeriod;
	scope: LeaderboardScope;
	timePeriods: readonly LeaderboardTimePeriod[];
	scopes: readonly LeaderboardScope[];
	onChange: (value: LeaderboardFilterValue) => void;
};

export const LeaderboardHeader = ({
	timePeriod,
	scope,
	timePeriods,
	scopes,
	onChange,
}: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	const periodButtons = timePeriods.map((value) => ({
		value,
		label: t(`leaderboard.periods.${value}`),
	}));

	const scopeFilters = scopes.map((value) => ({
		value,
		label:
			value === "friends" ? (
				<Box flexDirection="row" alignItems="center" gap={6}>
					<Text variant="bodyMedium">{t("leaderboard.scope.friends")}</Text>
					<Box
						borderRadius={4}
						paddingHorizontal={6}
						paddingVertical={2}
						style={{ backgroundColor: theme.colors.surfaceVariant }}
					>
						<Text
							variant="labelSmall"
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{t("leaderboard.friends.soon")}
						</Text>
					</Box>
				</Box>
			) : (
				t(`leaderboard.scope.${value}`)
			),
	}));

	return (
		<Box gap={12}>
			{periodButtons.length > 0 ? (
				<ConnectedButtonGroup
					value={timePeriod}
					onValueChange={(v) =>
						onChange({ timePeriod: v as LeaderboardTimePeriod, scope })
					}
					buttons={periodButtons}
				/>
			) : null}
			{scopeFilters.length > 0 ? (
				<FilterChipGroup
					value={scope}
					onValueChange={(v) =>
						onChange({ timePeriod, scope: v as LeaderboardScope })
					}
					filters={scopeFilters}
				/>
			) : null}
		</Box>
	);
};
